import { Injectable, Injector } from '@angular/core';
// import { LwActionsExecutor } from './lw-action-executor';
// import { LtmsCustomFieldRenderer } from './ltms-custom-field-renderer';
import { CustomFieldRenderer } from './ltms-custom-field-renderer-v2';

@Injectable({
    providedIn: 'root'
})
export class CommonService{
    constructor(
        private injector:Injector
    ){}
    // executeActionExecuter(actions: any, data: any, cb: any){
    //     const lwAction = this.injector.get(LwActionsExecutor)
    //     lwAction.execute(actions, data, cb)
    // }

    renderCustomFieldsWithAction(params:any,service:any){
        // const fieldRenderer = this.injector.get(CustomFieldRenderer)
        // fieldRenderer.init(params);
        const fieldRenderer = new CustomFieldRenderer(params,service)
        return fieldRenderer._renderAction();
    }
    renderCustomFields(params:any,service:any){
        // const fieldRenderer = this.injector.get(CustomFieldRenderer)
        // fieldRenderer.init(params);
        return  new CustomFieldRenderer(params,service);
    }
}